import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var UpdatePatientRes;
export const UpdatePatientTodo = createAsyncThunk('UpdatePatient', async (data) => {
    console.log(data)
    try {
        const res = await axios({
            method: "Put",
            url: process.env.REACT_APP_API_URL + `admin/patient/${data.id}`,
            data: {

                "company_id": localStorage.getItem('companyId'),
                "name": data.name,
                "phone": data.phone,
                "email": data.email,
                "age": data.age.toString(),
                "gender": data.gender,
                "status": data?.status,
                "modified_by": localStorage.getItem('user_id'),
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return UpdatePatientRes = res.data

    } catch (error) {
        return UpdatePatientRes = error.response.data
    }
})